// Get references to the checkbox inputs
const $checkboxes = $(".ais-dropdown-checkbox");
const $drawer = $(".all_filter_drawer");

$checkboxes.on("change", function () {
  const $currentCheckbox = $(this);

  if (!$currentCheckbox.prop("checked")) {
    // Uncheck all checkboxes except the selected one
    $checkboxes.each(function () {
      const $otherCheckbox = $(this);
      if (!$otherCheckbox.is($currentCheckbox)) {
        $otherCheckbox.prop("checked", true);
      }
    });

    // Find the closest dropdown element to the current checkbox
    const $currentDropdown = $currentCheckbox.closest(
      ".ais-facet-dropdown-wrapper"
    );

    // Scroll the drawer to make the current dropdown visible and centered
    if ($currentDropdown.length > 0) {
      const dropdownTop = $currentDropdown.position().top;
      const dropdownHeight = $currentDropdown.outerHeight();
      const drawerScrollTop = $drawer.scrollTop();
      const drawerHeight = $drawer.height();

      // Calculate the scroll distance needed to center the dropdown
      const scrollToPosition =
        dropdownTop + dropdownHeight / 2 - drawerHeight / 2;

      // Animate the scroll
      $drawer.animate({ scrollTop: scrollToPosition }, 500);
    }
  }
});


function addEventListenersForTracking() {
  let productNodes = document.querySelectorAll('.ais-InfiniteHits-item .product-card');
  let productArray = Array.from(productNodes);
  let algoliaProducts = [];


  // We need to wait for algolia to load the products
  if (productNodes.length < 1) {
    return setTimeout(function () {
      addEventListenersForTracking();
    }, 500);
  }

  productNodes.forEach((node) => {
    algoliaProducts.push({
      'item_name': node.dataset.algoliaTitle,
      'item_id': node.dataset.sku,
      'price': parseFloat(node.dataset.price),
      'item_brand': node.dataset.vendor,
      'item_variant': node.dataset.variant,
      'item_category': node.dataset.category,
      'item_category2': node.dataset.subcategory,
      'item_category3': node.dataset.producttype,
      'index': parseInt(node.dataset.algoliaPosition),
      'quantity': 1
    });

    node.addEventListener('click', function () {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        'event': 'select_item',
        'ecommerce': {
          'items': [{
            'item_name': node.dataset.algoliaTitle,
            'item_id': node.dataset.sku,
            'price': parseFloat(node.dataset.price),
            'item_brand': node.dataset.vendor,
            'item_variant': node.dataset.variant,
            'item_category': node.dataset.category,
            'item_category2': node.dataset.subcategory,
            'item_category3': node.dataset.producttype,
            'index':  parseInt(node.dataset.algoliaPosition),
            'item_list_name' : node.dataset.collections,
            'quantity': 1
          }]
          }
      });
    });
  });

   // We make the actual push to GTM
   dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
   dataLayer.push({
       'event': 'view_item_list',
       'ecommerce': {
           'items': algoliaProducts
       }
   });
}

addEventListenersForTracking();
